import _slicedToArray from "D:/a/1/s/Comfama.CentroDeAyuda.Home/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useId, useState, useEffect } from 'react';
import { ACCORDION_PREFIX } from '../utils/constants.js';
var current = 0;

var useIdShim = function useIdShim() {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      id = _useState2[0],
      setId = _useState2[1];

  useEffect(function () {
    return setId(++current);
  }, []);
  return id && "".concat(ACCORDION_PREFIX, "-").concat(id);
};

var _useId = useId || useIdShim;

export { _useId as useId };